/* @flow */
import * as React from 'react';

const ChatBubbles = props => (
  <svg
    width={32}
    height={25}
    viewBox="0 0 32 25"
    stroke="none"
    strokeWidth={1}
    fill="#FFF055"
    fillRule="evenodd"
    {...props}>
    <path d="M30.182,0 L13.818,0 C12.815,0 12,0.811 12,1.808 L12,7 L1.818,7 C0.815,7 0,7.811 0,8.808 L0,18.499 C0,19.298 0.563,20.104 1.818,20.104 L3.653,20.104 C3.543,21.326 2.984,22.379 1.983,23.243 C1.664,23.518 1.551,23.965 1.703,24.358 C1.852,24.746 2.224,25 2.637,25 L2.658,25 C3.273,24.987 4.2,24.929 5.14,24.569 C7.204,23.779 8.742,22.143 9.378,20.104 L18.182,20.104 C19.438,20.104 20,19.298 20,18.499 L20,13.104 L22.622,13.104 C23.259,15.143 24.796,16.779 26.86,17.569 C27.8,17.929 28.727,17.987 29.342,18 L29.363,18 C29.776,18 30.148,17.746 30.297,17.358 C30.448,16.964 30.336,16.518 30.017,16.243 C29.016,15.379 28.457,14.326 28.347,13.104 L30.182,13.104 C31.438,13.104 32,12.298 32,11.499 L32,1.808 C32,0.811 31.185,0 30.182,0 Z M18,18.104 L8.597,18.104 C8.115,18.104 7.701,18.448 7.614,18.922 C7.34,20.406 6.418,21.66 5.095,22.389 C5.56,21.368 5.748,20.234 5.647,19.02 C5.604,18.502 5.171,18.103 4.651,18.103 L2,18.103 L2,9 L18,9 L18,18.104 Z M30,11.104 L27.35,11.104 C26.829,11.104 26.397,11.503 26.354,12.021 C26.252,13.234 26.441,14.369 26.906,15.39 C25.584,14.661 24.662,13.407 24.387,11.922 C24.299,11.448 23.886,11.104 23.404,11.104 L20,11.104 L20,8.808 C20,7.811 19.185,7 18.182,7 L14,7 L14,2 L30,2 L30,11.104 Z" />
    <circle cx={6} cy={14} r={1} />
    <circle cx={10} cy={14} r={1} />
    <circle cx={14} cy={14} r={1} />
  </svg>
);

export default ChatBubbles;



// WEBPACK FOOTER //
// ./src/assets/images/icons/chat-bubbles.js